/* Ritual Lab Atelier · tema v4
   Menu, sacola (carrinho real da Shopify via Ajax API), seletor de fragrância, barra fixa de compra,
   filtro de presentes, atalhos da Ajuda e validação do encontro especial. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var R = (window.RL4 && window.RL4.routes) || { cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change", cartUpdate: "/cart/update", root: "/" };
  var fmt = new Intl.NumberFormat("pt-BR", { style: "currency", currency: (window.RL4 && window.RL4.moeda) || "BRL" });
  var money = function (cents) { return fmt.format(cents / 100).replace(/,00$/, ""); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };

  /* ---------- toast ---------- */
  var tt;
  function toast(msg) { var t = $("#toast"); if (!t) return; t.textContent = msg; t.classList.add("is-on"); clearTimeout(tt); tt = setTimeout(function () { t.classList.remove("is-on"); }, 2400); }

  /* ---------- menu e sacola (painéis) ---------- */
  var lastFocus = null;
  function lock(on) { document.body.classList.toggle("is-locked", on); }
  function openMenu() { var m = $("#menu"); if (!m) return; lastFocus = document.activeElement; m.classList.add("is-open"); m.setAttribute("aria-hidden", "false"); $("#menu-open").setAttribute("aria-expanded", "true"); lock(true); setTimeout(function () { $("#menu-close").focus(); }, 60); }
  function closeMenu() { var m = $("#menu"); if (!m || !m.classList.contains("is-open")) return; m.classList.remove("is-open"); m.setAttribute("aria-hidden", "true"); $("#menu-open").setAttribute("aria-expanded", "false"); lock(false); }
  function openCart() { lastFocus = document.activeElement; $("#drawer").classList.add("is-open"); $("#scrim").classList.add("is-open"); $("#drawer").setAttribute("aria-hidden", "false"); lock(true); setTimeout(function () { $("#cart-close").focus(); }, 380); }
  function closeCart() { $("#drawer").classList.remove("is-open"); $("#scrim").classList.remove("is-open"); $("#drawer").setAttribute("aria-hidden", "true"); lock(false); if (lastFocus && document.contains(lastFocus)) lastFocus.focus(); }
  document.addEventListener("click", function (e) {
    if (e.target.closest("#menu-open")) { openMenu(); return; }
    if (e.target.closest("#menu-close")) { closeMenu(); $("#menu-open").focus(); return; }
    if (e.target.closest("#cart-open")) { e.preventDefault(); refreshCart().then(openCart); return; }
    if (e.target.closest("#cart-close") || e.target.closest("#scrim") || e.target.closest("[data-close-cart]")) { closeCart(); return; }
  });
  document.addEventListener("keydown", function (e) { if (e.key !== "Escape") return; if ($("#drawer.is-open")) closeCart(); else if ($("#menu.is-open")) { closeMenu(); $("#menu-open").focus(); } });

  /* header some ao descer e volta ao subir */
  var lastY = 0;
  window.addEventListener("scroll", function () {
    var y = window.scrollY, hd = $("#header"); if (!hd) return;
    if (y > 240 && y > lastY + 4) hd.classList.add("is-hidden"); else if (y < lastY - 4 || y < 120) hd.classList.remove("is-hidden");
    lastY = y;
  }, { passive: true });

  /* ---------- sacola ---------- */
  var cartState = null, noteTimer;
  function fetchJSON(url, opts) { return fetch(url, Object.assign({ headers: { "Accept": "application/json" } }, opts || {})).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); }); }
  function refreshCart() { return fetchJSON(R.cart + ".js").then(function (c) { cartState = c; renderCart(); return c; }); }
  function renderCart() {
    var c = cartState; if (!c) return;
    $$("[data-count]").forEach(function (el) { el.textContent = c.item_count; el.dataset.n = c.item_count; });
    var btn = $("#cart-open"); if (btn) btn.setAttribute("aria-label", c.item_count ? "Sacola, " + c.item_count + (c.item_count === 1 ? " item" : " itens") : "Sacola, vazia");
    var body = $("[data-cart-body]"), foot = $("[data-cart-foot]"); if (!body) return;
    var empty = $("#cart-empty-tpl"), notes = $("#cart-notes-tpl");
    if (!c.item_count) { body.innerHTML = empty ? empty.innerHTML : ""; foot.innerHTML = ""; foot.hidden = true; return; }
    foot.hidden = false;
    body.innerHTML = c.items.map(function (it, i) {
      var line = i + 1, opt = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "";
      var img = it.image ? it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=160" : "";
      return '<div class="line">' + (img ? '<img src="' + esc(img) + '" alt="" width="72" height="90" loading="lazy">' : '<span></span>') +
        '<div><h3>' + esc(it.product_title) + '</h3>' + (opt ? '<p class="small">' + esc(opt) + '</p>' : '<p class="small"></p>') +
        '<div class="qty"><button type="button" data-line="' + line + '" data-q="' + (it.quantity - 1) + '" aria-label="Diminuir quantidade de ' + esc(it.product_title) + '">−</button><input value="' + it.quantity + '" readonly aria-label="Quantidade de ' + esc(it.product_title) + '"><button type="button" data-line="' + line + '" data-q="' + (it.quantity + 1) + '" aria-label="Aumentar quantidade de ' + esc(it.product_title) + '">+</button></div>' +
        '<button class="line__rm" type="button" data-line="' + line + '" data-q="0">Tirar da sacola</button></div>' +
        '<span class="line__price">' + money(it.final_line_price) + '</span></div>';
    }).join("") +
      '<div class="field"><label for="cart-note">Algum recado para o ateliê? Se for presente, conte aqui.</label><textarea id="cart-note" placeholder="Para quem é e o que escrever no cartão.">' + esc(c.note || "") + '</textarea></div>';
    foot.innerHTML = '<div class="sum"><span>Subtotal</span><span>' + money(c.total_price) + '</span></div>' + (notes ? notes.innerHTML : "") +
      '<a class="btn btn--block" href="/checkout">Fechar o pedido <span class="arrow" aria-hidden="true">→</span></a>' +
      '<button class="link" type="button" style="justify-self:center" data-close-cart>Continuar escolhendo</button>';
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest("#drawer [data-line]"); if (!b) return;
    b.disabled = true;
    fetchJSON(R.cartChange + ".js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, Math.min(10, +b.dataset.q)) }) })
      .then(function (c) { cartState = c; renderCart(); var again = $('#drawer [data-line="' + b.dataset.line + '"][aria-label^="' + (b.getAttribute("aria-label") || "").split(" ")[0] + '"]'); if (again) again.focus(); else $("#cart-close").focus(); })
      .catch(function () { toast("Não deu para mudar agora. Tente de novo."); b.disabled = false; });
  });
  document.addEventListener("input", function (e) {
    if (e.target.id !== "cart-note") return;
    clearTimeout(noteTimer); var v = e.target.value;
    noteTimer = setTimeout(function () { fetchJSON(R.cartUpdate + ".js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ note: v }) }).then(function (c) { cartState = c; }); }, 500);
  });

  /* ---------- produto ---------- */
  function initProduct(root) {
    var form = $("[data-rl4-buy]", root); if (!form) return;
    var picker = $("[data-picker]", root), img = $("[data-main-img]", root), notesEl = $("[data-frag-notes]", root);
    function selected() { var r = picker ? $("input[name=id]:checked", picker) : null; return picker ? r : $("input[name=id]", form); }
    function apply(r) {
      if (!r) return;
      picker.classList.remove("has-error");
      if (notesEl) notesEl.textContent = r.dataset.notes ? r.value && (r.dataset.label + ": " + r.dataset.notes + ".") : "";
      if (img && r.dataset.img) { img.src = r.dataset.img; img.removeAttribute("srcset"); img.alt = r.dataset.alt || img.alt; }
      $$("[data-thumb]", root).forEach(function (t, i) { t.setAttribute("aria-current", String(i === 0)); });
      var t0 = $("[data-thumb] img", root); if (t0 && r.dataset.img) t0.src = r.dataset.img;
    }
    if (picker) {
      picker.addEventListener("change", function (e) { if (e.target.name === "id") apply(e.target); });
      var pre = selected(); if (pre) apply(pre);
    }
    root.addEventListener("click", function (e) {
      var th = e.target.closest("[data-thumb]");
      if (th && img) { img.src = th.dataset.src; img.removeAttribute("srcset"); img.alt = th.dataset.alt || ""; $$("[data-thumb]", root).forEach(function (t) { t.setAttribute("aria-current", String(t === th)); }); return; }
      var q = e.target.closest("[data-qty]");
      if (q) { var inp = $("[name=quantity]", form); inp.value = Math.min(10, Math.max(1, (+inp.value || 1) + (+q.dataset.qty))); return; }
      var oa = e.target.closest("[data-open-acc]");
      if (oa) { var d = document.getElementById(oa.dataset.openAcc); if (d) { d.open = true; d.scrollIntoView({ block: "start" }); } }
    });
    function buy(e) {
      if (e) e.preventDefault();
      var r = selected();
      if (!r) {
        picker.classList.add("has-error");
        picker.scrollIntoView({ block: "center" });
        var first = $("input[name=id]", picker); if (first) first.focus({ preventScroll: true });
        return;
      }
      var btn = $("[type=submit]", form); btn.disabled = true;
      var fd = new FormData(form); if (!fd.get("id")) fd.set("id", r.value);
      fetchJSON(R.cartAdd + ".js", { method: "POST", body: fd })
        .then(function () { return refreshCart(); })
        .then(function () { openCart(); toast("Foi para a sacola."); })
        .catch(function (err) { toast((err && err.description) || "Não deu para levar agora. Tente de novo."); })
        .then(function () { btn.disabled = false; });
    }
    form.addEventListener("submit", buy);
    var bb = $("#buybar"), bbBtn = bb ? $("button", bb) : null, row = $("[data-buy-row]", root);
    if (bbBtn) bbBtn.addEventListener("click", function () { buy(); });
    if (bb && row && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) {
        var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        bb.classList.toggle("is-on", show); bb.setAttribute("aria-hidden", String(!show)); bbBtn.tabIndex = show ? 0 : -1;
      }).observe(row);
    }
  }
  $$("[data-product-root]").forEach(initProduct);

  /* ---------- presentes: filtro por companhia ---------- */
  $$("[data-chips]").forEach(function (group) {
    var grid = document.getElementById(group.dataset.chips), status = group.parentNode.querySelector("[data-filter-status]");
    function apply(f) {
      $$(".chip", group).forEach(function (c) { c.setAttribute("aria-pressed", String(c.dataset.f === f)); });
      var n = 0;
      $$(".card", grid).forEach(function (c) { var on = f === "tudo" || (c.dataset.with || "").split(" ").indexOf(f) > -1; c.hidden = !on; if (on) n++; });
      if (status) status.textContent = n + " opções";
    }
    group.addEventListener("click", function (e) { var b = e.target.closest(".chip"); if (b) apply(b.dataset.f); });
    var m = location.search.match(/[?&]com=([a-z]+)/); apply(m ? m[1] : "tudo");
  });

  /* ---------- ajuda: atalhos e abertura pelo endereço ---------- */
  function openGroup(id, focus) { var g = document.getElementById("faq-" + id); if (!g) return; var d = $("details", g); if (d) d.open = true; g.scrollIntoView({ block: "start" }); if (focus) { var s = $("summary", g); if (s) s.focus({ preventScroll: true }); } }
  document.addEventListener("click", function (e) { var j = e.target.closest("[data-faq-jump]"); if (j) openGroup(j.dataset.faqJump, true); });
  var fm = location.hash.match(/^#faq-([a-z-]+)$/); if (fm) setTimeout(function () { openGroup(fm[1]); }, 60);

  /* fragrância destacada ao chegar por um link de fragrância */
  if (/^#fr-[a-z]+$/.test(location.hash)) { var fr = $(location.hash); if (fr) { fr.classList.add("is-flash"); setTimeout(function () { fr.classList.remove("is-flash"); }, 1600); } }

  /* ---------- encontros: validação do encontro especial ---------- */
  $$("[data-encontro-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      var ok = true;
      $$("[data-req]", form).forEach(function (inp) {
        var f = inp.closest(".field"), v = inp.value.trim(), bad = !v;
        if (!bad && inp.type === "email") bad = !/@.+\./.test(v);
        if (!bad && inp.dataset.min) { var n = +v; bad = !(n >= +inp.dataset.min && n <= +inp.dataset.max); var em = $(".err", f); if (em && bad) em.textContent = n < +inp.dataset.min ? em.dataset.low : em.dataset.high; }
        f.classList.toggle("has-error", bad); inp.setAttribute("aria-invalid", String(bad));
        if (bad && ok) { inp.focus(); ok = false; }
      });
      if (!ok) e.preventDefault();
    });
  });

  refreshCart().catch(function () {});
})();
